import { StyleSheet } from 'react-native';
import { ticketColors, ticketFonts } from '../theme/public-api';

/** Filas / cabeceras de lista ticket. Cards paper sobre canvas mint. */
export const ticketList = StyleSheet.create({
  row: {
    flexDirection: 'column',
    alignItems: 'stretch',
    // Sin padding acá: lo lleva el Pressable (rowPad) para que el hover-lift
    // cubra la card completa y no solo el contenido.
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    marginBottom: 8,
  },
  /** Fila dentro de un PaperSheet agrupado (proto Square). */
  rowGrouped: {
    flexDirection: 'column',
    alignItems: 'stretch',
    borderRadius: 0,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    marginBottom: 0,
  },
  /** Padding de contenido de fila: va en el Pressable (o wrapper) — no en row. */
  rowPad: {
    paddingVertical: 14,
    paddingHorizontal: 14,
  },
  /** Filas con footer: el padding inferior lo aporta el footer propio. */
  rowPadTop: {
    paddingTop: 14,
    paddingHorizontal: 14,
  },
  /** Radio del pressable para que la sombra de hover siga la card (solo). */
  rowRadius: {
    borderRadius: 14,
  },
  rowGroupedLast: {
    borderBottomWidth: 0,
  },
  rowInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  rowInactive: {
    opacity: 0.55,
  },
  avatar: {
    width: 44,
    height: 44,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  thumbnail: {
    width: 44,
    height: 44,
    borderRadius: 10,
    flexShrink: 0,
    backgroundColor: ticketColors.tile,
  },
  thumbnailPlaceholder: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  /** Badge de ícono a la izquierda (proto .aic): 32px, tinte por tono. */
  leadingIconBadge: {
    width: 32,
    height: 32,
    borderRadius: 9,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  avatarText: {
    fontSize: 13,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  footer: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },
  /** Footer de fila pressable: la card ya no tiene padding — lo trae acá. */
  footerCard: {
    marginTop: 8,
    paddingTop: 8,
    paddingHorizontal: 14,
    paddingBottom: 14,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.ruleSoft,
  },
  main: {
    flex: 1,
    minWidth: 0,
    gap: 0,
  },
  name: {
    fontSize: 15,
    lineHeight: 20,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  meta: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 16,
    fontFamily: ticketFonts.sans,
    marginTop: 3,
  },
  chip: {
    alignSelf: 'flex-start',
    marginTop: 6,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  chipWarn: {
    alignSelf: 'flex-start',
    marginTop: 6,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
    backgroundColor: '#FFFBEB',
    borderWidth: 1,
    borderColor: 'rgba(180,83,9,0.28)',
  },
  chipBad: {
    alignSelf: 'flex-start',
    marginTop: 6,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 999,
    backgroundColor: '#FEF2F2',
    borderWidth: 1,
    borderColor: 'rgba(185,28,28,0.25)',
  },
  chipText: {
    fontSize: 10,
    fontWeight: '700',
    color: ticketColors.brandInk,
    fontFamily: ticketFonts.sans,
  },
  chipTextWarn: {
    fontSize: 10,
    fontWeight: '700',
    color: '#B45309',
    fontFamily: ticketFonts.sans,
  },
  chipTextBad: {
    fontSize: 10,
    fontWeight: '700',
    color: '#B91C1C',
    fontFamily: ticketFonts.sans,
  },
  trail: {
    flexShrink: 0,
    alignItems: 'flex-end',
    gap: 4,
  },
  /** Pill rellena junto al status (pago, origen) — paleta la fija el row. */
  trailingPill: {
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  trailingPillText: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.2,
    fontFamily: ticketFonts.sans,
  },
  value: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.4,
  },
  /** Aclaración bajo el monto (proto gastos: "de $48.500"). */
  valueSub: {
    fontSize: 11,
    fontWeight: '500',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  /** Valor como pill brand (beneficio de promo: 2×1, 5%). */
  valuePill: {
    paddingVertical: 4,
    paddingHorizontal: 9,
    borderRadius: 999,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.brandBorderSoft,
  },
  valuePillText: {
    fontSize: 12,
    fontWeight: '800',
    color: ticketColors.brandInk,
    fontFamily: ticketFonts.sans,
  },
  /** Link inline "Ver ›" junto al chevron (proto .see-all). */
  linkLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.brandPrimary,
    fontFamily: ticketFonts.sans,
  },
  tableHead: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
    gap: 12,
    backgroundColor: ticketColors.tile,
  },
  th: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  thNum: {
    width: 88,
    textAlign: 'right',
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.sans,
  },
  tdNum: {
    width: 88,
    textAlign: 'right',
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
  },
  tdNumStrong: {
    width: 88,
    textAlign: 'right',
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.mono,
    fontVariant: ['tabular-nums'],
  },
});
